export default (words, query) => {
  if (query && query.length >= 3 && words && words.includes(query)) {
    return words.split(query).join("<span class='highlight-text'>" + query + "</span>");
  } else return words;
};
